import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sbnb-calendar-header-date',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="date"
      [class.is-weekend]="date | isWeekend"
      [class.is-today]="date | isToday"
      [class.is-first-day-of-month]="(date | date: 'd') === '1'">
      <div class="date-dateofmonth">
        {{ date | date: 'd' }}
      </div>
      <div class="date-dayofweek">{{ date | date: 'EEE' }}</div>
    </div>
  `,
  styleUrls: ['./calendar-header-date.component.scss'],
})
export class CalendarHeaderDateComponent implements OnInit {
  @Input() date: Date;
  constructor() { }

  ngOnInit(): void { }
}
